/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap-v5'
import { Formik, Form, Field, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import { useIntl } from 'react-intl'
import { NumericFormat } from 'react-number-format'
import { PaymentRequestModel } from '../../../models/PaymentRequestModel'
import { revertPriceNumner } from '../../../selectors'
import { AsyncSelect2Supplier } from '../../../../_metronic/partials/select/AsyncSelect2Supplier'

type Props = {
    show: boolean
    mode: string
    data?: PaymentRequestModel
    onClose: () => void
    onSubmit: (values: any, actions: any) => void
    onUpdateStatus: (status: string, id?: number) => void
}
const editSchema = Yup.object().shape({
    supplier_id: Yup.string().nullable().required('Vui lòng chọn nhà cung cấp'),
    amount: Yup.string().required('Vui lòng nhập giá trị')
})

const PaymentRequestEditModal: React.FC<Props> = ({ show, mode, data, onClose, onSubmit, onUpdateStatus }) => {
    const intl = useIntl();
    const [initValues, setInitValues] = useState<PaymentRequestModel>({})

    useEffect(() => {
        setInitValues({
            id: data?.id,
            supplier: data?.supplier,
            supplier_id: data?.supplier_id,
            address: data?.supplier?.address ?? '',
            amount: data?.amount ?? 0,
            status: data?.status ?? '',
            payment_method: data?.payment_method ?? 'banking',
            note: data?.note ?? ''
        })
    }, [data]) 

    const editAble = ['pending', 'paid'].includes(data?.status ?? ''); 
    return (
        <Modal
            show={show}
            onHide={onClose}
            aria-labelledby='contained-modal-title-vcenter'
            centered
        >
            <Modal.Header className='d-flex'>
                <Modal.Title>Yêu cầu thanh toán #{data?.request_code ?? ''}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="px-10">
                <Formik enableReinitialize validationSchema={editSchema} initialValues={initValues} onSubmit={onSubmit}>
                    {({ values, handleChange }) => (
                        <Form>
                            <div className="d-flex flex-column  gap-5 pt-3">
                                <div className="fv-row flex-row-fluid fv-plugins-icon-container">
                                    <label className="required form-label">Nhà cung cấp</label>
                                    <Field className="form-select cursor-pointer"
                                    as="select"
                                    disabled={true}
                                    name="supplier">
										<option value={values?.supplier_id ?? ''}>{ values?.supplier?.name ?? '' }</option>
									</Field>
                                </div>
                                <div className="fv-row flex-row-fluid fv-plugins-icon-container">
                                    <label className="form-label">Địa chỉ</label>
                                    <Field
                                        type='text'
                                        className='form-control'
                                        placeholder=''
                                        autoComplete='nope'
                                        disabled
                                        name='address'
                                    />
                                    <div className="fv-plugins-message-container invalid-feedback">
                                        <ErrorMessage name='address' />
                                    </div>
                                </div>
                                <div className="fv-row flex-row-fluid fv-plugins-icon-container">
                                    <label className="required form-label">Số tiền thu</label>
                                    <NumericFormat
                                        thousandSeparator=","
                                        name='amount'
                                        className='form-control'
                                        required
                                        disabled={true}
                                        value={values?.amount ?? 0}
                                        onBlur={(e) => {
                                            handleChange({target: {name: 'amount', value: revertPriceNumner(e.target.value)}});
                                        }}
                                    />
                                    <ErrorMessage name='value' className='text-danger' component='span' />
                                </div>
                                <div className="fv-row flex-row-fluid fv-plugins-icon-container">
                                    <label className="form-label">Ghi chú</label>
                                    <Field
                                        as="textarea"
                                        className="form-control"
                                        value={values.note ?? ""}
                                        id="note"
                                        name="note"
                                        disabled={!editAble}
                                        rows={3}
                                    />
                                    <div className="fv-plugins-message-container invalid-feedback"><ErrorMessage name='note' /></div>
                                </div>
                                <div className='fv-row flex-row-fluid fv-plugins-icon-container'>
                                    <label className='form-label' htmlFor="status">
										Trạng thái
									</label>
									<Field 
                                        className="form-select cursor-pointer"
                                        as="select"
                                        name="status"
                                        disabled={!editAble}
                                    >
										<option value="pending">Đang chờ xử lý</option>
										<option value="paid">Đã thanh toán</option>
										<option disabled value="confirmed">Đã xác nhận</option>
									</Field>
                                </div>
                                <div className='fv-row flex-row-fluid fv-plugins-icon-container'>
                                    <label className='form-label' htmlFor="payment_method">
                                        Phương thức thanh toán
                                    </label>
                                    <Field 
                                        disabled={!editAble}
                                        className="form-select cursor-pointer" 
                                        as="select" 
                                        name="payment_method"
                                    >
                                        <option value="banking">Chuyển khoản</option>
                                        <option value="cash">Tiền mặt</option>
                                    </Field>
                                </div>
                            </div>
                            <div className='d-flex mb-4 justify-content-between pt-8'>
                                <button className="btn btn-bg-secondary" type="button" onClick={() => onClose()}>Đóng</button>
                                {(editAble) && (
                                    <>
                                        <button className="btn btn-bg-primary ms-2" type="submit">Lưu</button>
                                    </>
                                )}
                                
                            </div>
                        </Form>
                    )}
                </Formik>
            </Modal.Body>
        </Modal>
    )
}

export default PaymentRequestEditModal
